import { render, staticRenderFns } from "./ProductRecommendationItem.vue?vue&type=template&id=65a78770&"
import script from "./ProductRecommendationItem.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports